module.exports = __webpack_public_path__ + "img/banner_title.d3da49e8.png";